import Document from '../../services/document'
import * as types from '../mutationTypes'

let state = {
  errorDoc: null,
  id: null,
  status: '',
  documents: [],
  documentsByTask: [],
  headers: [//  will need to update if want to display WO#-Task# in a table
    { text: 'Id', value: 'id' },
    { text: 'Task ID', value: 'workOrderTaskId' },
    { text: 'Uploaded By', value: 'user' },
    { text: 'Document Type ID', value: 'documentType' },
    { text: 'File Name', value: 'fileName' },
    { text: 'Description', value: 'description' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  selectList (state) {
    return state.documents.map(document => {
      return { text: document.url, value: document.id }
    })
  },
  id (state) {
    return state.id
  },
  documents (state) {
    return state.documents
  },
  headers () {
    return state.headers
  },
  errorDocument (state) {
    return state.errorDoc
  },
  documentsByTask (state) {
    return state.documentsByTask
  },
  status (state) {
    return state.status
  }
}

const actions = {
  async loadAllDocuments ({ commit, dispatch }, limit, offset) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.get(limit, offset)
      if (res) {
        commit(types.REQUEST_GET_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_DOCUMENT_ERROR, 'Error getting documents')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadDocsByTask ({ commit, dispatch }, taskId) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.getByTask(taskId)
      if (res) {
        let data = res.data
        commit(types.REQUEST_GET_DOCUMENT_TASK_SUCCESS, data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_DOCUMENT_TASK_ERROR, 'Error getting documents')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async createDocument ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.create(data)
      if (res) {
        commit(types.REQUEST_CREATE_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async uploadDocument ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.upload(data)
      if (res) {
        commit(types.REQUEST_UPLOAD_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_UPLOAD_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async uploadCreateDocument ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.uploadCreate(data)
      if (res) {
        commit(types.REQUEST_UPLOAD_DOCUMENT_SUCCESS, res.data)

        res.data.forEach(async function (uploaded) {
          if (uploaded.description === 'XPF FORM') {
            let res = await Document.getDocument(uploaded.id)
            const file = new Blob([res.data], { type: res.headers['content-type'] })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = uploaded.fileName
            link.click()
          }
        })

        return res.data
      }
    } catch (err) {
      commit(types.REQUEST_UPLOAD_DOCUMENT_ERROR, err)
      return null
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateDocument ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.update(data)
      if (res) {
        commit(types.REQUEST_UPDATE_DOCUMENT_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_UPLOAD_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteDocument ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Document.deleteDocument(data)
      if (res) {
        commit(types.REQUEST_DELETE_DOCUMENT_SUCCESS, res.data)
        return res
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getDocLink ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      const document = data
      // If the document is a PDF it can be opened in a new window for viewing
      // otherwise it will auto download
      if (document.fileName.endsWith('.pdf')) {
        let res = await Document.getUrl(document.id)
        if (res) {
          let win = window.open(res.data, '_blank')
          win.focus()
        }
      } else {
        let res = await Document.getFile(document.id)
        if (res) {
          const file = new Blob([res.data], { type: res.headers['content-type'] })
          let link = window.document.createElement('a')
          link.href = window.URL.createObjectURL(file)
          link.download = data.fileName
          link.click()
        }
        commit(types.REQUEST_GET_DOCUMENT_SUCCESS)
      }
    } catch (err) {
      commit(types.REQUEST_GET_DOCUMENT_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_ERROR_DOCUMENT)
  },
  clearDocumentTasks ({ commit }) {
    commit(types.CLEAR_DOCUMENT_TASK)
  }
}

const mutations = {
  [types.REQUEST_UPLOAD_DOCUMENT_SUCCESS] (state, data) {
    state.errorDoc = null
  },
  [types.REQUEST_UPLOAD_DOCUMENT_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.REQUEST_GET_DOCUMENT_TASK_SUCCESS] (state, data) {
    state.errorDoc = null
    state.documentsByTask = data
  },
  [types.REQUEST_GET_DOCUMENT_TASK_ERROR] (state, message) {
    state.errorDoc = message
    state.documentsByTask = []
  },
  [types.REQUEST_DELETE_DOCUMENT_SUCCESS] (state, data) {
    state.errorDoc = null
  },
  [types.REQUEST_DELETE_DOCUMENT_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.REQUEST_UPDATE_DOCUMENT_SUCCESS] (state, data) {
    state.errorDoc = null
    state.status = 'Saved'
  },
  [types.REQUEST_UPDATE_DOCUMENT_ERROR] (state, message) {
    state.errorDoc = message
    state.status = 'Error'
  },
  [types.REQUEST_CREATE_DOCUMENT_SUCCESS] (state, data) {
    state.errorDoc = null
  },
  [types.REQUEST_CREATE_DOCUMENT_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.REQUEST_GET_DOCUMENTS_SUCCESS] (state, data) {
    state.documents = data
    state.errorDoc = null
  },
  [types.REQUEST_GET_DOCUMENTS_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.REQUEST_GET_DOCUMENT_SUCCESS] (state) {
    state.errorDoc = null
  },
  [types.REQUEST_GET_DOCUMENT_ERROR] (state, message) {
    state.errorDoc = message
  },
  [types.CLEAR_ERROR_DOCUMENT] (state) {
    state.errorDoc = null
  },
  [types.CLEAR_DOCUMENT_TASK] (state) {
    state.documentsByTask = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
